@import "theme/lp20/colors";
@import "tooltipster/tooltipster.css";

#download-native-apps-modal {
  display: block;
  overflow: auto;

  .modal-header {
    border-bottom: none;
    margin-top: .5rem;

    img.oe-logo {
      height: 5rem;
      margin: auto;
      user-select: none;
    }
  }

  .modal-body {
    font-size: 1.5rem;

    .app-links {
      display: flex;
      justify-content: center;
      margin-top: 2rem;

      #google-play-link > img {
        position: relative;
        top: -10px;
        width: 154px;
      }
    }
  }
}

.login-page {
	min-width: 860px;
}

.login-page #content {
    text-align: center;
    height: 100%;
}

.login .login-container {
    width: 860px;
}

.login .login-container .login-account {
    padding-left: 0;
}

.login-container .login-social-login {
    float: right;
    width: 370px;
}

.login-container .login-social-login .login-social-holder:nth-child(2n) {
    float: right;
}

.login-container .login-social-login .login-social-holder {
    float: left;
    width: 150px;
}

.login .login2-container {
  width: 380px;
}

.login2-social-login {
  margin-top: 30px;
  text-align: center;
}

.login2-social-login .login2-social-holder {
  display: inline-block;
  height: 34px;
  padding-left: 30px;
  padding-right: 30px;
  width: 34px;
}

.login2-links-holder {
  font: 12px/12px ProximaNovaSemiBold;
  text-align: center;
}

.login2-links-holder > div {
  display: inline-block;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 20px;
  max-width: 150px;
}

.login2-links-holder > div:last-child {
  max-width: 300px;
}

.login2-links-holder label,
.login2-links-holder a {
  color: #0084ff;
}

.login2-links-holder .login2-remember-holder label {
  display: inline;
  padding-left: 2px;
}

i.remember-help {
  color: #0084ff;
  font-size: 14px;
  vertical-align: middle;
}

i.faq-chevron {
  font-size: 12px;
  position: relative;
  left: -18px;
}

#login2-link-back-to-login {
  color: #0084ff;
}

#footer {
  height: 120px;
  bottom: 0;
  display: table-footer-group;
  left: 0;
  position: fixed;
  width: 100%;
  z-index: 91;
}

td {
  padding: 4px;
  vertical-align: bottom;
}

.login-msg {
  text-align: center;
  font: 18px/20px "ProximaNova-Bold";
  color: $dark-grey;
}

.login-error-msg {
  text-align: center;
  font: 18px/20px "ProximaNova-Bold";
  color: #FF0000;
}

.login-lable {
  font: 16px/20px "ProximaNovaSemiBold", Arial, Verdana, Helvetica, sans-serif;
  color: $grey-120;
  margin-bottom: 20px;
}

.login-block{
  padding: 50px 0;
}

.login-block .plan-text {
  font-weight: bold;
}

.loginwith-block h3{
  color:$human-blue;
  font:22px/28px "ProximaNovaT-Thin";
  margin:0 0 9px;
}

.loginwith-block h3.login-with-holder{
  margin-top: 30px;
  font-weight: bold;
}

.login-title,
.plan-text {
  padding:0 5px 9px 102px;
  float:left;
  font:36px/40px"ProximaNovaT-Thin";
}

.plan-text-small{
  padding: 4px 0 0 0;
  float:left;
  font:18px/30px"ProximaNovaT-Thin";
}

.container_12 .prefix_4 {
  padding-left:435px;
}

.container_12 .suffix_4 {
  padding-right:435px;
}

.login-form .form-block{
  width:100%;
  border-top:none;
  border-bottom:none;
  background:none;
  padding:35px 0 35px;
  z-index: 3;
  position: relative;
}

.login2-form-block {
  padding: 20px 0 30px !important;
}

.login-form .form-block .input-holder{
  margin-bottom: 0px;
}

.login-form .form-block .input-holder input[type="text"],
.login-form .form-block .input-holder input[type="password"]{
  font-family: ProximaNovaSemiBold;
  border:1px solid #D9D9D9;
  border-radius: 4px;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  font-size:12px;
  line-height:17px;
  padding: 10px 10px 10px;
  margin: 10px 0px 0px 0px;
  display: block;
}

.login2-form .form-block .input-holder input[type="text"],
.login2-form .form-block .input-holder input[type="password"] {
  margin-left: auto;
  margin-right: auto;
}

.login-form .form-block .input-holder input[type="text"].error,
.login-form .form-block .input-holder input[type="password"].error {
  color: $red-orange;
  border:1px solid $red-orange;
}

.login-form .form-block label{
  font: 12px/20px ProximaNovaSemiBold;
}

.login-form .form-block .remember-holder {
  margin-top: 5px;
  padding-left: 25px;
  float: left;
}

.login-form .form-block .remember-holder label {
  display: inline;
  padding-left: 2px;
}

.login-button{
  float:left;
  font: 12px/35px ProximaNova-Bold;
  height: 36px;
  min-width:106px;
}

.login2-button {
  font: 12px/35px ProximaNova-Bold;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  width: 306px;
}

#recovery-submit {
  margin-bottom: 20px;
}

input[type="submit"]:disabled
{
  cursor: default;
  color:#b4b4b4;
}

.reset-button{
  float:left;
  font:11px/10px "ProximaNova";
  height: 34px;
  min-width:144px;
}

.forgot-password{
  float:right;
  padding:5px 0px 0;
}

.need-activation{
  float:right;
  padding:5px 0px 0;
}

.footer-nav a{
  color: white;
}

.login-form .form-block h3{
  color:$OELogo-blue;
  font:26px/30px "ProximaNova";
  margin: 15px 0;
}

.chk-area {
  float: left;
  width: 23px;
  height: 20px;
  background:url("../images/bg-checkbox.png") no-repeat;
  margin:3px 5px 2px 0;
}

.login-action-holder {
  width: 100%;
}

.login-action-holder td {
  vertical-align: middle;
}

.login-links {
  float: right;
}

.loginwith-block a.social-icon {
  min-height: 10px;
}

.loginwith-block .social-icon {
  margin-top: 5px;
}

.loginwith-block .social-icon:hover {
  margin-top: 0;
}

.logo {
  margin-bottom: 6px;
}

.captcha {
  position: relative;
}

.captcha img {
  float: right;
  width: 80px;
  height: 35px;
}

.login2-captcha img {
  width: 80px;
  height: 35px;
  display: inline-block;
  top: 19px;
  position: relative;
  margin-left: 5px;
}

.login-form .form-block .input-holder .captcha input[type="text"] {
  width: 190px;
}

.login-form .form-block .input-holder .login2-captcha input[type="text"] {
  display: inline-block;
  margin-left: 38px;
  width: 190px;
}

.marginLR10{
  margin-left: 10px !important;
  margin-right: 10px !important;
}

.submit-button{
  padding-top: 10px;
}

.bg-old-1{
  background: url("../images/login/aspen.jpg") no-repeat center center;
}
.bg-old-2{
  background: url("../images/login/chicago.jpg") no-repeat center center;
}
.bg-old-3{
  background: url("../images/login/honolulu.jpg") no-repeat center center;
}
.bg-old-4{
  background: url("../images/login/las_vegas.jpg") no-repeat center center;
}
.bg-old-5{
  background: url("../images/login/los_angeles.jpg") no-repeat center center;
}
.bg-old-6{
  background: url("../images/login/miami.jpg") no-repeat center center;
}
.bg-old-7{
  background: url("../images/login/new_york.jpg") no-repeat center center;
}
.bg-old-8{
  background: url("../images/login/san_francisco.jpg") no-repeat center center;
}
.bg-old-9{
  background: url("../images/login/seattle.jpg") no-repeat center center;
}
.bg-old-10{
  background: url("../images/login/washington_dc.jpg") no-repeat center center;
}

.bg-1 {
  background: url("../images/login/login1.jpg") no-repeat center center;
}
.bg-2 {
  background: url("../images/login/login2.jpg") no-repeat center center;
}
.bg-3 {
  background: url("../images/login/login3.jpg") no-repeat center center;
}
.bg-4 {
  background: url("../images/login/login4.jpg") no-repeat center center;
}
.bg-5 {
  background: url("../images/login/login5.jpg") no-repeat center center;
}
.bg-6 {
  background: url("../images/login/login6.jpg") no-repeat center center;
}
.bg-7 {
  background: url("../images/login/login7.jpg") no-repeat center center;
}
.bg-8 {
  background: url("../images/login/login8.jpg") no-repeat center center;
}
.bg-9 {
  background: url("../images/login/login9.jpg") no-repeat center center;
}
.bg-10 {
  background: url("../images/login/login10.jpg") no-repeat center center;
}
.bg-11 {
  background: url("../images/login/login11.jpg") no-repeat center center;
}
.bg-12 {
  background: url("../images/login/login12.jpg") no-repeat center center;
}
.bg-13 {
  background: url("../images/login/login13.jpg") no-repeat center center;
}
.bg-14 {
  background: url("../images/login/login14.jpg") no-repeat center center;
}
.bg-15 {
  background: url("../images/login/login15.jpg") no-repeat center center;
}
.bg-16 {
  background: url("../images/login/login16.jpg") no-repeat center center;
}
.bg-17 {
  background: url("../images/login/login17.jpg") no-repeat center center;
}
.bg-18 {
  background: url("../images/login/login18.jpg") no-repeat center center;
}

.blur-effect, .login-bg{
/* 	background: url("http://wallpapr.biz/wp-content/uploads/Seattle-Skyline-Washington-At-Night.jpg") no-repeat center center; */
    background-attachment: fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    width: 100%;
    position: relative;
}

.blur-effect{
    width: 100%;
    height:100%;
    filter:url(#gaussian-blur);
    -webkit-filter: blur(8px);
    -moz-filter: blur(8px);
    -o-filter: blur(8px);
    -ms-filter: blur(8px);
    filter: blur(8px);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
}
div.transparency {
    background-color: white;
    content: "";
    opacity: 0.7;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}

div.login2-backdrop {
  background-color: white;
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 1;
}

.login-form {
    position: relative;
}

.login-form div.login-wrapper{
    width: 100%;
    position: relative;
    z-index: 2;
    margin: 60px 0 120px;
    box-shadow: 0 2px 3px 0px $dark-grey;
    text-align: left;
}

.login-form div.login2-wrapper {
  -webkit-box-shadow: 20px 20px 5px 0px rgba(0,0,0,0.1);
  -moz-box-shadow: 20px 20px 5px 0px rgba(0,0,0,0.1);
  box-shadow: 20px 20px 5px 0px rgba(0,0,0,0.1);
  margin: 0 auto 0 auto;
  position: relative;
  text-align: left;
  width: 380px;
  z-index: 2;
}

div.login2-modal-header {
  margin-left: auto;
  margin-right: auto;
  padding-top: 30px;
  position: relative;
  width: 251px;
  z-index: 4;
}

div.login2-modal-header .login2-logo {
  text-indent: -9999px;
  overflow: hidden;
  background: url("../images/logo_black_lg.png") no-repeat scroll 0 0 transparent;
  height: 97px;
}

.login2-recovery-instructions {
  margin-top: 10px;
  text-align: center;
}

.login-form .form-block .login2-recovery-email-container > p{
  font: 14px/22px ProximaNovaSemiBold;
  margin-top: 20px;
  margin-left: 48px;
  text-align: left;
}

.login-form .form-block .login2-recovery-instructions > h3 {
  color: #0084ff;
  font: 14px/22px ProximaNovaSemiBold;
  margin-bottom: 0;
  margin-top: 0;
}

.login-form .form-block .login2-recovery-instructions > p {
  font: 12px/16px ProximaNovaSemiBold;
  margin: 0 30px 0 30px;
}

svg{
    height: 0;
    position: fixed;
}

.login-help {
    margin: 15px 0;
}

.login-help a {
    font: 12px/20px ProximaNovaSemiBold;
    margin-right: 5px;
}

.login-footer {
    display: table-row;
}

.login-footer .footer-nav {
    display: table-cell;
    padding: 35px 20px;
    text-align: center;
    vertical-align: middle;
}

.login-footer .footer-nav li {
    display: table-cell;
    float: none;
    padding-right: 15px;
    vertical-align: bottom;
}

.footer-nav li.footer-text {
	font: 30px/40px "ProximaNovaT-Thin";
}

.footer-nav li.footer-text-small {
	font: 20px/40px "ProximaNovaT-Thin";
}

#login_content.content-holder {
    padding-top: 0;
    display: table-cell;
    vertical-align: middle;
    width: 100%;
}

#header, #footer {
	position: absolute;
}

i.migration-banner-chevron {
  color: #fff;
  float: right;
  font-size: 10px;
  padding-top: 9px;
  padding-right: 6px;
}

div.faq-area {
  margin-left: auto;
  margin-right: auto;
  width: 960px;
}

div.faq-area > h3 {
  font: 26px/32px "ProximaNova", Arial, Verdana, Helvetica, sans-serif;
  color: #666;
}

div.faqs {
  margin-top: 12px;
}

div.faq-item {
  border-bottom: solid 2px #aed4ed;
}

div.faq-item:first-child {
  border-top: solid 2px #aed4ed;
  border-bottom: solid 2px #aed4ed;
}

h5.faq-question {
  cursor: pointer;
  padding: 10px 20px 10px 40px;
}

p.faq-answer {
  background: lightgray;
  border-top: solid 2px #aed4ed;
  display: none;
  padding: 20px;
}

div.intro-area {
  height: 250px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  width: 960px;
}

div.intro-area > h3 {
  color: #0084ff;
  font: 32px/42px "ProximaNova", Arial, Verdana, Helvetica, sans-serif;
  padding-top: 55px;
}

div.intro-area > p {
  font: 16px/32px "ProximaNova", Arial, Verdana, Helvetica, sans-serif;
}

div.intro-area > img {
  float: right;
}

div.return-area {
  margin-bottom: 120px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 90px;
  text-align: center;
}

div.return-area > a {
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  width: 250px;
}

div.return-area > h3 {
  color: #0084ff;
  font: 16px/24px "ProximaNova", Arial, Verdana, Helvetica, sans-serif;
}

#faq-footer {
  background: #464646;
  bottom: 0;
  color: #666;
  display: table-footer-group;
  height: 70px;
  left: 0;
  position: fixed;
  text-align: center;
  width: 100%;
  z-index: 91;
}

#faq-footer > p {
  margin-top: 24px;
}

#pwResetSuccess {
  overflow: hidden;
  width: 500px;
}

#pwResetSuccess.lightbox-frame .text-holder {
  min-height: 0;
  padding: 20px;
  width: auto;
}

#pwResetSuccess > div.btn-holder > a {
  margin: 0 20px 20px auto;
	width: 250px;
}

// Migration banner
#login_content > div.migration-banner {
  position: absolute;
  background-color: #fff;
  width: 380px;
  top: 60px;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 22;
}

#login_content > div.migration-banner > div.banner-title {
  background-color: #f4c208;
  color: #fff;
  cursor: pointer;
  font: 18px/28px "ProximaNova", Arial, Verdana, Helvetica, sans-serif;
  height: 28px;
}

#login_content > div.migration-banner > div.banner-content {
  display: none;
}

#login_content > div.migration-banner > div.banner-content > p {
  font: 16px/20px "ProximaNova", Arial, Verdana, Helvetica, sans-serif;
  padding: 20px;
}

#login_content > div.migration-banner > div.banner-content > a.migration-continue-btn {
  margin: 0 20px 20px 20px;
}

#login_content > div.bg-overlay {
  display: none;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background-color: black;
  opacity: 0.7;
  z-index: 21;
}

// Custom remember me CSS3 checkbox
#rememberLogin {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
}

#rememberLogin + label {
  background-image: url("../images/checkboxes/web-two-style-15px.png");
  padding-top: 0;
  padding-left: 18px;
  height: 15px;
  display: inline-block;
  line-height: 15px;
  background-repeat: no-repeat;
  background-position: 0 0;
  vertical-align: middle;
  cursor: pointer;
}

#rememberLogin:checked + label {
  background-position: 0 -15px;
}

#rememberLogin + label > p {
	padding-top: 1px;
}



// WEBPACK FOOTER //
// ./css/login.scss